import { useAProgressBar } from "../components/ui"
import { send } from "../services/api"

const useFormSend = async (e, config = {}, fields, form = {}) => {

    const progress = useAProgressBar()

    for(let k in fields) {
        if(fields[k].error) {
            return
        }
    }

    progress.show()

    let data = {}

    for(let k in fields) {
        data[k] = fields[k].value
    }

    let respData = await send(config.url, { method: config.method }, data)

    e.target.reset()

    if(form.processed) {
        form.processed = false
    }

    for(let k in fields) {
        if(!fields[k].hasOwnProperty('hidden')) {
            fields[k].value = ''
        }
    }

    setTimeout(() => {
        progress.hide()
    }, 500);
    return respData;
}

export {
    useFormSend
}